import React from 'react';
import './SiteLogo.css';

const SiteLogo = ({ className = '', onDark = true, alt = 'Luma TV' }) => (
    <img
        src="/assets/logo-luma.svg"
        alt={alt}
        className={`site-logo ${onDark ? 'site-logo-on-dark' : ''} ${className}`.trim()}
    />
);

export default SiteLogo;
